import Modal from '@/components/atoms/modal/modal';
import { Button, Typography } from '@comfama/comfama-ui-react';
import './libranzasConfirmacionPago.scss';

export interface LibranzasConfirmacionPagoProps {
    open: boolean;
    cancelarLabel: string;
    continuarLabel: string;
    onCancelar: () => void;
    onContinuar: () => void;
    continuarDisabled?: boolean;
    titulo?: string;
    descripcion?: string;
    imagenUrl?: string;
    /** Texto de advertencia mostrado antes de la descripción (ej. pago repetido a la misma referencia). */
    advertencia?: string;
}

const LibranzasConfirmacionPago = ({
    open,
    cancelarLabel,
    continuarLabel,
    onCancelar,
    onContinuar,
    continuarDisabled,
    titulo = '',
    descripcion = '',
    imagenUrl = '',
    advertencia = '',
}: LibranzasConfirmacionPagoProps) => {

    return (
        <Modal open={open} onClose={onCancelar}>
            <div className="m-libranzas-confirmacion-pago">
                {imagenUrl && (
                    <img
                        src={imagenUrl}
                        alt={titulo}
                        className="m-libranzas-confirmacion-pago__image"
                    />
                )}
                <Typography variant="h6">{titulo}</Typography>
                {advertencia && (
                    <Typography variant="body1" className="m-libranzas-confirmacion-pago__advertencia">
                        {advertencia}
                    </Typography>
                )}
                <Typography variant="body1">{descripcion}</Typography>
                <div className="m-libranzas-confirmacion-pago__buttons">
                    <Button variant="outlined" color="primary" onClick={onCancelar}>
                        {cancelarLabel}
                    </Button>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={onContinuar}
                        disabled={continuarDisabled}
                    >
                        {continuarLabel}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default LibranzasConfirmacionPago;
